import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { CorporationsView } from "@containers/admin/CorporationsView";

const CorporationsPage = () => {
    return (
        <AuthenticatedLayout adminPage activeMenuItem="corporations">
            <CorporationsView maxW={400} />
        </AuthenticatedLayout>
    );
};

export default CorporationsPage;
